import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { ROUTES } from '@routes/routes';
import { Image } from '@components/Image';
import {
  getCompetitionStatusName,
  getCompetitionFormatName,
} from '../../../../helpers';
import { CompetitionDetailsList } from '../../../../components/CompetitionDetailsList';
import { RankingPodiumOverlay } from '../RankingPodiumOverlay';
import { ICompletedCompetition } from './interfaces';

export const CompletedCompetition: React.FC<ICompletedCompetition> = ({
  slug,
  title,
  format,
  discipline,
  weaponGroups,
  status,
  description,
  enrollmentCount,
  imgSrc,
  startDate,
  endDate,
  detailsRoute,
  podium,
}): JSX.Element => {
  const navigate = useNavigate();

  const formatName = getCompetitionFormatName(format);
  const statusName = getCompetitionStatusName(status);

  const onCompetitionClick = (): void => {
    navigate(
      detailsRoute ?? ROUTES.portal.competitions.results.details(slug)
    );
  };

  return (
    <Card>
      <CardActionArea onClick={onCompetitionClick}>
        <Box sx={{ position: 'relative' }}>
          <Image
            imageSrc={imgSrc}
            aspectRatio={4 / 2}
            sx={{
              mt: 0,
              border: 'none',
              borderRadius: 0,
            }}
          />
          <RankingPodiumOverlay podium={podium} enrollmentCount={enrollmentCount} />
        </Box>
        <CardContent>
          <Typography
            variant="h5"
            component="div"
            fontSize="1rem"
            fontWeight="bold"
          >
            {title}
          </Typography>
          <Typography
            sx={{
              mb: '.8em',
            }}
            variant="body2"
            fontSize=".8rem"
            color="text.secondary"
          >
            {discipline}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>

          <Divider
            sx={{
              my: '10px',
            }}
          />
          <CompetitionDetailsList
            startDate={startDate}
            endDate={endDate}
            statusName={statusName}
            participants={enrollmentCount}
            formatName={formatName}
            weaponGroups={weaponGroups}
          />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
